import { useEffect } from "react";

import { useEvents } from "hooks/useEvents";
import { useNavigate } from "react-router-dom";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";

function TVEvent() {
  const events = useEvents();
  const navigate = useNavigate();

  useEffect(() => {
    if (events && events.length > 0) {
      const lastEvent = events[0];

      navigate(`/tv/${lastEvent.id}`);
    }
  }, [events, navigate]);

  return <ActivityIndicator />;
}

export { TVEvent };
